// extracted by extract-css-chunks-webpack-plugin
module.exports = {"homeAbout":"homeAbout_zfZiU mb-[55px] text-black"};